module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/FREE_XP_AND_CREW_XP.dff052b3.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/FREE_XP_AND_CREW_XP.png
// module id = 1157
// module chunks = 16